import React, { Component } from 'react';
import Header from './components/Header.js'
import Footer from './components/Footer.js'
import './styles/App.css';
import {
  Route,
  HashRouter
} from "react-router-dom";

import Home from './components/Home.js';
import Empresa from './components/Empresa.js';
import Servicio from './components/Servicio.js';
import Ventajas from './components/Ventajas.js';
import Laboratorio from './components/Laboratorio.js';
import Contacto from './components/Contacto.js';
import Modelo from './components/Modelo.js'
import Landing from './components/Landing.js'
import * as urlLogin from './config/urlLogins.js';
import { library } from '@fortawesome/fontawesome-svg-core'
import { faStroopwafel } from '@fortawesome/free-solid-svg-icons'
import ReactGA from 'react-ga';

library.add(faStroopwafel)

//false es el default no hace falta especificar, pero se deja para cuando quieran usar el debug mode
ReactGA.initialize('UA-125637656-1', { debug: true });

class App extends Component {
  closeModal(){
    var modals = document.getElementsByClassName("modal")
    
    Array.prototype.slice.call(modals).forEach(function(element){
        if(element.classList.contains("sidenav")){
            element.style.width = "0";
        }else{
            element.style.display = "none";
        }
    })

    let overlay = document.getElementById("overlay")
    overlay.style.backgroundColor = "unset"
    overlay.style.zIndex = "-2"
  }

  render() {
    return (
      <HashRouter>
        <div className="App">
        <div class="overlay" id="overlay" onClick={this.closeModal}></div>
          <Header />
          <div className="content">
            <Route exact path='/transfer' component={() => { window.location = urlLogin.TRANSFERS; return null;} }/>
            <Route exact path='/portaldrogueria' component={() => { window.location = urlLogin.PORTALDROGUERIAS; return null;} }/>
            <Route exact path="/" component={Home}  />
            <Route path="/empresa" component={Empresa} />
            <Route path="/servicios" component={Servicio} />
            <Route path="/ventajas" component={Ventajas} />
            <Route path="/laboratorios" component={Laboratorio} />
            <Route path="/contacto" component={Contacto} />   
            <Route path="/modelo" component={Modelo} /> 
            <Route path="/landing" component={Landing} />    
          </div>
          <Footer />
        </div>
      </HashRouter>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js